/**
 * Tailwind's preflight strips list markers and heading sizes, so each element
 * a rendered message body can contain needs an explicit rule. Sizing is
 * inherited from the caller's `className` so a 12px thread bubble and a 14px
 * panel can share it. Used by `MarkdownContent`.
 */
export const MARKDOWN_PROSE = [
  "max-w-none break-words",
  "[&>*:first-child]:mt-0 [&>*:last-child]:mb-0",
  "[&_p]:my-2",
  "[&_ul]:my-2 [&_ul]:list-disc [&_ul]:pl-5",
  "[&_ol]:my-2 [&_ol]:list-decimal [&_ol]:pl-5",
  "[&_li]:my-0.5",
  "[&_h1]:my-2 [&_h1]:text-base [&_h1]:font-semibold",
  "[&_h2]:my-2 [&_h2]:text-sm [&_h2]:font-semibold",
  "[&_h3]:my-2 [&_h3]:text-sm [&_h3]:font-medium",
  "[&_strong]:font-semibold",
  "[&_em]:italic",
  "[&_a]:text-primary [&_a]:underline",
  "[&_code]:rounded [&_code]:bg-muted [&_code]:px-1 [&_code]:py-0.5",
  "[&_pre]:my-2 [&_pre]:overflow-x-auto [&_pre]:rounded [&_pre]:bg-muted [&_pre]:p-2",
  "[&_pre_code]:bg-transparent [&_pre_code]:p-0",
  "[&_blockquote]:my-2 [&_blockquote]:border-l-2 [&_blockquote]:border-border [&_blockquote]:pl-3",
  "[&_hr]:my-3 [&_hr]:border-border",
  // Agent replies are often raw HTML email, which carries sized images and fixed-width
  // layout tables. Both would otherwise push the bubble past its max width.
  "[&_img]:max-w-full [&_img]:h-auto",
  "[&_table]:my-2 [&_table]:block [&_table]:max-w-full [&_table]:overflow-x-auto",
  "[&_th]:border [&_th]:border-border [&_th]:px-2 [&_th]:py-1",
  "[&_td]:border [&_td]:border-border [&_td]:px-2 [&_td]:py-1",
].join(" ");
